import { ReactElement, useEffect, useRef } from "react";
import icons from "./icons.module.css"

type IconName = "save" | "retry" | "spinner" | "close" | "download"

export const Icon = ({ icon }: { icon: IconName }): ReactElement => <span className={`${icons.icon} ${icons[icon]}`}></span>